<template>
  <div class="flag-container">
    <div
      class="switch-lang"
      v-on:click="isHidden = !isHidden"
      @mouseover="isHidden = false"
      @mouseleave="isHidden = true"
    >
      <div class="current-lang">
        <span :class="'lang-flag ' + selectedLanguageIcon" />
        <p class="lang-text">{{ selectedLanguageText }}</p>
      </div>

      <div id="lang-dropdown" class="lang-dropdown" v-if="!isHidden">
        <div
          class="selecting-lang"
          v-on:click="($i18n.locale = 'es'), firstFocus()"
        >
          <span class="lang-flag flag-icon-es" />
          <p class="lang-text">Español</p>
        </div>
        <div
          class="selecting-lang"
          v-on:click="($i18n.locale = 'en'), firstFocus()"
        >
          <span class="lang-flag flag-icon-en" />
          <p class="lang-text">English</p>
        </div>
        <div
          class="selecting-lang"
          v-on:click="($i18n.locale = 'it'), firstFocus()"
        >
          <span class="lang-flag flag-icon-it" />
          <p class="lang-text">Italiano</p>
        </div>
        <div
          class="selecting-lang"
          v-on:click="($i18n.locale = 'pt'), firstFocus()"
        >
          <span class="lang-flag flag-icon-pt" />
          <p class="lang-text">Português</p>
        </div>
        <div
          class="selecting-lang"
          v-on:click="($i18n.locale = 'fr'), firstFocus()"
        >
          <span class="lang-flag flag-icon-fr" />
          <p class="lang-text">Français</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./css/languageSelector.css"></style>

<script>
export default {
  props: ["focus"],
  name: "LanguageSelector",
  data: () => ({
    isHidden: true
  }),
  computed: {
    selectedLanguageIcon() {
      return "flag-icon-" + this.$i18n.locale;
    },
    selectedLanguageText() {
      switch (this.$i18n.locale) {
        case "es":
          return "Español";
        case "en":
          return "English";
        case "it":
          return "Italiano";
        case "pt":
          return "Português";
        case "fr":
          return "Français";
      }
      return "flag-icon-" + this.$i18n.locale;
    }
  },
  methods: {
    firstFocus() {
      if (this.focus != null) {
        document.querySelector(this.focus).focus();
      }
    }
  }
};
</script>
